module.exports = __webpack_public_path__ + "static/media/vf_wskirt_core.b76c5d8e.svg";